import { createSlice } from '@reduxjs/toolkit'
import {
  fetchDepartment,
  fetchById,
  updateDepartment,
  addDepartment,
  fetchOrgDropDown,
  createDepartment,
  exportDepartmentsCSV,
  fetchAllDepartmentsDropdowns,
  updateStatusInDepartment
} from './thunk'

interface DepartmnetState {
  departmentList: any[]
  rowCount: number
  loading: boolean
  error: string | null
  selectedOrganisation: any
  orgDropDown: any[]
  departDropdown:any[]
  orgDropDownLoading: boolean
  orgDropDownError: string | null
  createDepartmentLoading: boolean
  createDepartmentError: string | null
  exportCSVLoading: boolean
  exportCSVError: string | null 
}

const initialState: DepartmnetState = {
  departmentList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  orgDropDownLoading: false,
  orgDropDownError: null,
  createDepartmentLoading: false,
  createDepartmentError: null,
  exportCSVLoading: false,
  exportCSVError: null, 
  departDropdown:[]
}

const departmentSlice = createSlice({
  name: 'department',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch All Departments
      .addCase(fetchDepartment.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDepartment.fulfilled, (state, action) => {
        state.loading = false
        state.departmentList = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount =
          typeof action.payload.rowCount === 'number'
            ? action.payload.rowCount
            : 0
      })
      .addCase(fetchDepartment.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch departments'
      })

      // Fetch Department by ID
      .addCase(fetchById.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchById.fulfilled, (state, action) => {
        state.loading = false
        state.selectedOrganisation = action.payload
      })
      .addCase(fetchById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Update Department
      .addCase(updateDepartment.fulfilled, (state, action) => {
        if (!action.payload?.id) return
        state.departmentList = state.departmentList.map(org =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update department'
      })

      // Fetch Organisation Dropdown
      .addCase(fetchOrgDropDown.pending, state => {
        state.orgDropDownLoading = true
        state.orgDropDownError = null
      })
      .addCase(fetchOrgDropDown.fulfilled, (state, action) => {
        state.orgDropDownLoading = false
        state.orgDropDown = action.payload || []
      })
      .addCase(fetchOrgDropDown.rejected, (state, action) => {
        state.orgDropDownLoading = false
        state.orgDropDownError =
          action.error.message || 'Failed to fetch organizations'
      })

      // Create Department
      .addCase(createDepartment.pending, state => {
        state.createDepartmentLoading = true
        state.createDepartmentError = null
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.createDepartmentLoading = false
        state.createDepartmentError = null
        if (action.payload?.id) {
          state.departmentList.unshift(action.payload)
          state.rowCount += 1
        }
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.createDepartmentLoading = false
        state.createDepartmentError =
          typeof action.payload === 'string'
            ? action.payload
            : action.error.message || 'Failed to create department'
      })
      .addCase(fetchAllDepartmentsDropdowns.fulfilled, (state, action) => {
            state.orgDropDown = action.payload.orgDropDown || []
            state.departDropdown = action.payload.departDropdown || []
           
          })

      // Export Department CSV
      .addCase(exportDepartmentsCSV.pending, state => {
        state.exportCSVLoading = true
        state.exportCSVError = null
      })
      .addCase(exportDepartmentsCSV.fulfilled, state => {
        state.exportCSVLoading = false
        state.exportCSVError = null
      })
      .addCase(exportDepartmentsCSV.rejected, (state, action) => {
        state.exportCSVLoading = false
        state.exportCSVError =
          typeof action.payload === 'string'
            ? action.payload
            : action.error.message || 'Failed to export CSV'
      })
            // Update Status in Department
      .addCase(updateStatusInDepartment.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(updateStatusInDepartment.fulfilled, (state, action) => {
        state.loading = false
        const updated = action.payload
        if (!updated?.department_id) return

        state.departmentList = state.departmentList.map(dep =>
          dep.department_id === updated.department_id ? updated : dep
        )
      })
      .addCase(updateStatusInDepartment.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update department status'
      })

  },
})

export default departmentSlice.reducer
